import React from 'react';
import { Navigate, useLocation } from 'react-router';
import routes from './routes';

const isTerminalAllowedPath = (pathname) =>
  pathname === routes.root ||
  pathname === routes.priceChecker ||
  pathname === routes.picking ||
  pathname.startsWith(`${routes.picking}/`);

export const HandlePublicRoutes = ({ children, isAuthenticated, user }) => {
  const location = useLocation();
  if (isAuthenticated && location.pathname === routes.login) {
    return <Navigate to={routes.root} replace />;
  }
  return children;
};

export const HandlePrivateRoutes = ({ children, isAuthenticated, user }) => {
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to={routes.login} replace />;
  }
  if (user.rolesAdmin && location.pathname !== routes.admin) {
    return <Navigate to={routes.admin} replace />;
  }
  if (user.rolesStocks && location.pathname !== routes.stocks) {
    return <Navigate to={routes.stocks} replace />;
  }
  if (user.rolesTerminal && !isTerminalAllowedPath(location.pathname)) {
    return <Navigate to={routes.root} replace />;
  }
  if (!children) {
    if (user.rolesAdmin) return <Navigate to={routes.admin} replace />;
    if (user.rolesStocks) return <Navigate to={routes.stocks} replace />;
    if (user.rolesTerminal) return <Navigate to={routes.root} replace />;
    return <Navigate to={routes.login} replace />;
  }
  return children;
};

export const HandleLogout = ({ logoutUser }) => {
  logoutUser();
  return <Navigate to={routes.login} replace />;
};
